module.exports = __webpack_public_path__ + "static/media/logo.92ca8d51.png";